export default "__VITE_ASSET__4GbDHai9__"